import _ from "lodash";
import {
  APPLY_INITIAL_STATE,
  FETCH_TABLE_REQUEST,
  FETCH_TABLE_SUCCESS,
  FETCH_TABLE_FAILURE,
  FETCH_TABLE_CANCEL,
  FETCH_MORE_TABLE_REQUEST,
  FETCH_MORE_TABLE_SUCCESS,
  FETCH_MORE_TABLE_FAILURE,
  FETCH_MORE_TABLE_CANCEL,
  FETCH_GRAPH_REQUEST,
  FETCH_GRAPH_SUCCESS,
  FETCH_GRAPH_FAILURE,
  FETCH_GRAPH_CANCEL,
  ADD_SELECTED_SEARCH_TERM_GRAPH,
  REMOVE_SELECTED_SEARCH_TERM_GRAPH,
  DEFAULT_GRAPH_OPTIONS,
  CHANGE_SELECTED_OPTIONS_PER_GRAPH,
  TOGGLE_CHAT_AGENT, // Add this import
  SEND_MESSAGE, // Add these
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAILURE,
  CLEAR_CHAT_HISTORY,
} from "./constants";

const initialState = {
  tableData: [],
  graphData: [],
  isLoading: false,
  loadingMore: false,
  hasMore: true,
  selectedSearchTermsGraphs: [],
  graphOptions: {},
  // Add these chat-related properties
  isChatOpen: false,
  chatMessages: [],
  chatLoading: false,
  chatError: null,
};

const brandPerformanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPLY_INITIAL_STATE: {
      return initialState;
    }

    // Chat toggle case
    case TOGGLE_CHAT_AGENT:
    case 'TOGGLE_CHAT_AGENT':
    case 'brandPerformance/TOGGLE_CHAT_AGENT':
      return {
        ...state,
        isChatOpen: !state.isChatOpen,
      };

    // Chat message cases - ADD THESE
    case SEND_MESSAGE:
    case 'SEND_MESSAGE':
    case 'brandPerformance/SEND_MESSAGE':
      return {
        ...state,
        chatMessages: [
          ...state.chatMessages,
          {
            id: Date.now(),
            type: 'USER',
            content: action.payload,
            timestamp: new Date().toISOString(),
          }
        ],
        chatLoading: true,
        chatError: null,
      };

    case SEND_MESSAGE_SUCCESS:
    case 'SEND_MESSAGE_SUCCESS':
    case 'brandPerformance/SEND_MESSAGE_SUCCESS':
      return {
        ...state,
        chatMessages: [
          ...state.chatMessages,
          {
            id: Date.now() + 1, // Ensure unique ID
            type: 'AGENT',
            content: action.payload.content || action.payload,
            timestamp: new Date().toISOString(),
            charts: action.payload.charts || [],
            tables: action.payload.tables || [],
            data: action.payload.data || null,
            metadata: action.payload.metadata || null,
          }
        ],
        chatLoading: false,
      };

    case SEND_MESSAGE_FAILURE:
    case 'SEND_MESSAGE_FAILURE':
    case 'brandPerformance/SEND_MESSAGE_FAILURE':
      return {
        ...state,
        chatLoading: false,
        chatError: action.payload?.error || 'Something went wrong',
      };

    case CLEAR_CHAT_HISTORY:
    case 'CLEAR_CHAT_HISTORY':
    case 'brandPerformance/CLEAR_CHAT_HISTORY':
      return {
        ...state,
        chatMessages: [],
        chatError: null,
      };

    // Your existing cases
    case FETCH_TABLE_REQUEST:
      return {
        ...state,
        isLoading: true,
        loadingMore: true,
        tableData: [],
        graphData: [],
      };

    case FETCH_TABLE_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        isLoading: false,
        loadingMore: false,
        tableData: data,
      };
    }

    case FETCH_TABLE_CANCEL:
      return {
        ...state,
        isLoading: false,
        loadingMore: false,
        tableData: null,
      };

    case FETCH_TABLE_FAILURE:
      return {
        ...state,
        isLoading: false,
        loadingMore: false,
        tableData: null,
      };

    case FETCH_GRAPH_REQUEST: {
      const { searchTerm, id } = action.payload;
      return {
        ...state,
        graphData: {
          ...state.graphData,
          [searchTerm]: {
            ...state.graphData[searchTerm],
            [id]: null,
          },
        },
      };
    }

    case FETCH_GRAPH_SUCCESS: {
      const { searchTerm, id, data } = action.payload;
      return {
        ...state,
        graphData: {
          ...state.graphData,
          [searchTerm]: {
            ...state.graphData[searchTerm],
            [id]: data,
          },
        },
      };
    }

    case FETCH_GRAPH_CANCEL: {
      const { searchTerm, id } = action.payload;
      return {
        ...state,
        graphData: {
          ...state.graphData,
          [searchTerm]: {
            ...state.graphData[searchTerm],
            [id]: null,
          },
        },
      };
    }

    case FETCH_GRAPH_FAILURE: {
      const { searchTerm, id } = action.payload;
      return {
        ...state,
        graphData: {
          ...state.graphData,
          [searchTerm]: {
            ...state.graphData[searchTerm],
            [id]: null,
          },
        },
      };
    }

    case CHANGE_SELECTED_OPTIONS_PER_GRAPH: {
      const { searchTerm, id, value } = action.payload;
      return {
        ...state,
        graphOptions: {
          ...state.graphOptions,
          [searchTerm]: state.graphOptions[searchTerm].map((item, index) =>
            index === id ? value : item
          ),
        },
      };
    }

    case ADD_SELECTED_SEARCH_TERM_GRAPH: {
      const { searchTerm } = action.payload;
      return {
        ...state,
        selectedSearchTermsGraphs: [
          ...state.selectedSearchTermsGraphs,
          searchTerm,
        ],
        graphOptions: {
          ...state.graphOptions,
          [searchTerm]: DEFAULT_GRAPH_OPTIONS,
        },
      };
    }

    case REMOVE_SELECTED_SEARCH_TERM_GRAPH: {
      const { searchTerm } = action.payload;
      return {
        ...state,
        selectedSearchTermsGraphs: state.selectedSearchTermsGraphs.filter(
          (item) => item !== searchTerm
        ),
      };
    }
  }

  return state;
};

export default brandPerformanceReducer;
